import type { Platform, PlatformInfo } from './types'

/**
 * Platform Detection Utilities
 * Runtime detection of platform and OS
 */

/**
 * Detect current platform
 */
export function detectPlatform(): Platform {
  return typeof window !== 'undefined' && 'api' in window && window.api !== undefined
    ? 'electron'
    : 'web'
}

/**
 * Check if running in Electron
 */
export function isElectron(): boolean {
  return detectPlatform() === 'electron'
}

/**
 * Check if running in Web
 */
export function isWeb(): boolean {
  return detectPlatform() === 'web'
}

/**
 * Detect OS
 */
export function detectOS(): 'mac' | 'windows' | 'linux' | 'unknown' {
  if (typeof navigator === 'undefined') return 'unknown'

  const userAgent = navigator.userAgent.toLowerCase()
  const platform = navigator.platform?.toLowerCase() || ''

  if (userAgent.includes('mac') || platform.includes('mac')) {
    return 'mac'
  } else if (userAgent.includes('win') || platform.includes('win')) {
    return 'windows'
  } else if (userAgent.includes('linux') || platform.includes('linux')) {
    return 'linux'
  }

  return 'unknown'
}

/**
 * Get platform information
 */
export function getPlatformInfo(): PlatformInfo {
  const platform = detectPlatform()
  const os = detectOS()

  return {
    platform,
    isElectron: platform === 'electron',
    isWeb: platform === 'web',
    isMac: os === 'mac',
    isWindows: os === 'windows',
    isLinux: os === 'linux',
  }
}
